import React from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { formatCurrency } from "./bookingPricingUtils";

export default function BookingStepPayment({
  event,
  paymentMethod,
  onPaymentMethodChange,
  paymentError,
  totalAmount,
  paymentRequired,
}) {
  const bankTransferCustomText = String(
    event?.registrationConfig?.bankTransferInfo?.customText || ""
  ).trim();

  if (!paymentRequired) {
    return (
      <Paper variant="outlined" sx={{ p: 2.25 }}>
        <Stack spacing={1}>
          <Typography variant="subtitle2">Zahlungsart</Typography>
          <Alert severity="success">
            Für diese Anmeldung fällt keine Gebühr an. Eine Zahlungsart ist nicht erforderlich.
          </Alert>
        </Stack>
      </Paper>
    );
  }

  return (
    <Box>
      <Paper variant="outlined" sx={{ p: 2.25 }}>
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <Typography variant="subtitle2">Zahlungsart wählen</Typography>
            <Typography variant="body2" color="text.secondary">
              Offener Betrag für diese Buchung: <strong>{formatCurrency(totalAmount)}</strong>
            </Typography>
          </Stack>

          <FormControl component="fieldset" error={Boolean(paymentError)} required>
            <FormLabel component="legend">Wie soll die Gebühr bezahlt werden?</FormLabel>
            <RadioGroup
              value={paymentMethod}
              onChange={(eventValue) => onPaymentMethodChange(eventValue.target.value)}
            >
              <FormControlLabel
                value="sepa"
                control={<Radio size="small" />}
                label="Per Lastschrift vom Vertragsinhaber einziehen"
              />
              <FormControlLabel
                value="bank_transfer"
                control={<Radio size="small" />}
                label="Per Überweisung bezahlen"
              />
            </RadioGroup>
            {paymentError ? <FormHelperText>{paymentError}</FormHelperText> : null}
          </FormControl>

          {paymentMethod === "sepa" && (
            <Alert severity="info">
              Die Gebühr wird nach erfolgreicher Anmeldung vom Inhaber des hinterlegten Vertragskontos per SEPA-Lastschrift eingezogen.
            </Alert>
          )}

          {paymentMethod === "bank_transfer" && (
            <Stack spacing={1}>
              <Alert severity="info">
                Die Gebühr muss überwiesen werden. Kontodaten sehen Sie im nächsten Schritt in der Zusammenfassung und zusätzlich in der Bestätigungs-E-Mail.
              </Alert>
              {bankTransferCustomText ? (
                <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
                  {bankTransferCustomText}
                </Typography>
              ) : null}
            </Stack>
          )}
        </Stack>
      </Paper>
    </Box>
  );
}

BookingStepPayment.propTypes = {
  event: PropTypes.object,
  paymentMethod: PropTypes.oneOf(["", "sepa", "bank_transfer"]),
  onPaymentMethodChange: PropTypes.func.isRequired,
  paymentError: PropTypes.string,
  totalAmount: PropTypes.number,
  paymentRequired: PropTypes.bool,
};

BookingStepPayment.defaultProps = {
  event: null,
  paymentMethod: "",
  paymentError: "",
  totalAmount: 0,
  paymentRequired: false,
};
